import { z } from 'zod';

export const LogoSchema = z.enum(['psAccess', 'accountUpdates']);
export type Logo = z.infer<typeof LogoSchema>;

export const TopNavConfigSchema = z.object({
  iconColor: z.string(),
  customLogo: z.string().optional(),
  hideAppsIcon: z.boolean().optional(),
});
export type TopNavConfig = z.infer<typeof TopNavConfigSchema>;

export const PlatformMultiClientConfigForClientSchema = z.object({
  pageTitle: z.string(),
  logo: LogoSchema,
  topNav: TopNavConfigSchema,
  hideMainBarAppIcons: z.boolean().optional(),
  buttonPrimaryClassName: z.string().optional(),
});
export type PlatformMultiClientConfigForClient = z.infer<typeof PlatformMultiClientConfigForClientSchema>;
